// extracted by mini-css-extract-plugin
export default {"container":"e1-z","list":"f1-z"};